var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.263 27.402C477.512 27.402 529.248 37.693 577.519 57.6874C625.79 77.6819 669.65 106.988 706.595 143.933L425.263 425.264L425.263 27.402Z",
    fill: "url(#paint0_linear_61_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.933 143.933C180.878 106.988 224.738 77.6818 273.009 57.6873C321.28 37.6928 373.016 27.4019 425.264 27.4019V425.264L143.933 143.933Z",
    fill: "url(#paint1_linear_61_16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.958C823.036 478.206 812.655 529.925 792.576 578.161C772.498 626.397 743.115 670.205 706.105 707.086L425.266 425.264L823.127 425.958Z",
    fill: "url(#paint2_linear_61_16)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M706.596 143.933C743.541 180.878 772.847 224.738 792.841 273.008C812.836 321.279 823.127 373.016 823.127 425.264H425.264L706.596 143.933Z",
    fill: "url(#paint3_linear_61_16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M425.264 823.127C373.016 823.127 321.279 812.836 273.008 792.841C224.737 772.847 180.877 743.54 143.932 706.595L425.264 425.264L425.264 823.127Z",
    fill: "url(#paint4_linear_61_16)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M706.595 706.595C669.65 743.54 625.79 772.847 577.52 792.841C529.249 812.836 477.512 823.127 425.264 823.127V425.264L706.595 706.595Z",
    fill: "url(#paint5_linear_61_16)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4022 425.265C27.4022 373.017 37.6932 321.28 57.6877 273.009C77.6821 224.738 106.988 180.878 143.933 143.933L425.265 425.265L27.4022 425.265Z",
    fill: "url(#paint6_linear_61_16)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.934 706.595C106.989 669.65 77.6828 625.79 57.6884 577.519C37.6939 529.248 27.4029 477.512 27.4029 425.264H425.265L143.934 706.595Z",
    fill: "url(#paint7_linear_61_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_16",
    x1: 392.471,
    y1: 179.045,
    x2: 619.66,
    y2: 203.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_16",
    x1: 227.973,
    y1: 274.348,
    x2: 514.776,
    y2: 103.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_16",
    x1: 676.431,
    y1: 416.798,
    x2: 602.569,
    y2: 634.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_16",
    x1: 596.558,
    y1: 241.378,
    x2: 728.276,
    y2: 542.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_61_16",
    x1: 458.056,
    y1: 671.484,
    x2: 230.867,
    y2: 647.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_61_16",
    x1: 609.15,
    y1: 596.558,
    x2: 325.276,
    y2: 688.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_61_16",
    x1: 179.045,
    y1: 458.057,
    x2: 203.363,
    y2: 230.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_61_16",
    x1: 271.401,
    y1: 613.852,
    x2: 119.776,
    y2: 337.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors8);
export default __webpack_public_path__ + "static/media/sectors-8.2e85b77cb9d4e20e60fc7149d557cb7b.svg";
export { ForwardRef as ReactComponent };